import { useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { parseBoolean } from '../utils'

export const useAssetParams = () => {
    const location = useLocation()
    const [params, setParams] = useState(null)
    const [route, setRoute] = useState(null)

    useEffect(() => {
        const searchSplit = location.search.split(':')
        setParams({
            userID: searchSplit[0].replace('?', ''),
            workspaceID: searchSplit[1],
            invite: searchSplit[2] || null,
            isDev: parseBoolean(searchSplit[3]) || null,
            object: searchSplit[4],
        })
        const pathSplit = location.pathname.split('/')
        setRoute(pathSplit[pathSplit.length - 1])
    }, [])

    return { params, route }
}
